import React, { useState } from "react";
export const AdminContext = React.createContext(null);

export const AdminProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [medicine, setMedicine] = useState(null);

  const setProfile = (profile) => {
    setUser(profile);
  };

  const removeProfile = () => {
    setUser(null);
  };

  const saveMedicine = (medicine) => {
    setMedicine(medicine);
  };
  const removeMedicine = () => {
    setMedicine(null);
  };

  return (
    <AdminContext.Provider
      value={{
        user,
        setProfile,
        removeProfile,
        medicine,
        saveMedicine,
        removeMedicine,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
